const withSuffix = (source, suffix) =>
  typeof source === "string" && /\.jpe?g$/i.test(source)
    ? source.replace(/\.jpe?g$/i, `${suffix}.jpg`)
    : null;

export function productImageSrcSet(source) {
  const small = withSuffix(source, "-480");
  const medium = withSuffix(source, "-800");
  return small && medium
    ? `${small} 480w, ${medium} 800w, ${source} 1200w`
    : undefined;
}

export function editorialImageSrcSet(source) {
  if (source === "/main/hero-pantry.jpg") {
    return "/main/hero-pantry-900.jpg 900w, /main/hero-pantry-1500.jpg 1500w, /main/hero-pantry.jpg 2200w";
  }

  if (source === "/main/about-kitchen.jpg") {
    return "/main/about-kitchen-800.jpg 800w, /main/about-kitchen-1400.jpg 1400w, /main/about-kitchen.jpg 1800w";
  }

  if (source === "/main/journal-kitchen.jpg") {
    return "/main/journal-kitchen-800.jpg 800w, /main/journal-kitchen-1400.jpg 1400w, /main/journal-kitchen.jpg 1536w";
  }

  if (source === "/main/wholesale-pantry.jpg") {
    return "/main/wholesale-pantry-800.jpg 800w, /main/wholesale-pantry-1400.jpg 1400w, /main/wholesale-pantry.jpg 1536w";
  }

  return productImageSrcSet(source);
}
